module.exports = __webpack_public_path__ + "img/risks-weight-gain.e2ab12eb.svg";